import React from "react";
import { string } from "prop-types";
import cx from "classnames";
import assetify from "@quintype/framework/assetify";

import WhatsApp from "../../atoms/icon/whatsapp-new.svg";
import Facebook from "../../atoms/icon/facebook-new.svg";
import Twitter from "../../atoms/icon/twitter-new.svg";

import "./sticky-social-share.m.css";

const StickySocialShareTemplate = props => {
  const socialShareStyle = cx({
    "social-share": true,
    open: true
  });

  return (
    <div styleName="sticky-social-share">
      <ul styleName={socialShareStyle}>
        <li styleName="social-share-icon">
          <a href={props.twitterUrl} target="_blank" rel="noopener noreferrer">
            <img src={`${assetify(Twitter)}`} alt="Twitter" />
          </a>
        </li>
        <li styleName="social-share-icon">
          <a href={props.fbUrl} target="_blank" rel="noopener noreferrer">
            <img src={`${assetify(Facebook)}`} alt="Facebook" />
          </a>
        </li>
        <li styleName="social-share-icon">
          <a href={props.whatsappUrl} target="_blank" rel="noopener noreferrer">
            <img src={`${assetify(WhatsApp)}`} alt="WhatsApp" />
          </a>
        </li>
      </ul>
    </div>
  );
};

StickySocialShareTemplate.propTypes = {
  color: string,
  twitterUrl: string,
  fbUrl: string,
  gplusUrl: string,
  whatsappUrl: string
};

export default StickySocialShareTemplate;
